"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JobCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _icon = require("@site/pattern-library-utils/icon");
/**
 * Local Imports
 */

const Job = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Job",
  class: "pl-j1h9yhql"
});
const JobInner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "JobInner",
  class: "pl-j1miqq33"
});
const SharedStyles = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SharedStyles",
  class: "pl-s1qgs3fx"
});
const JobTitle = /*#__PURE__*/(0, _react2.styled)(SharedStyles)({
  name: "JobTitle",
  class: "pl-js6vbx6"
});
const JobLocation = /*#__PURE__*/(0, _react2.styled)(SharedStyles)({
  name: "JobLocation",
  class: "pl-jhv3pm2"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)(SharedStyles)({
  name: "ButtonContainer",
  class: "pl-b1180eew"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-i11i5uw0"
});

/**
 * JobCard Component.
 *
 * @param {Object} props React props
 * @param {String} props.jobTitle Job Title
 * @param {String} props.jobDepartment Job Department
 * @param {String} props.jobLocation Job Location
 * @param {String} props.jobUrl Job Listing Url
 * @returns {React.ReactElement} JobCard Component
 * @public
 */
function JobCard({
  jobTitle,
  jobDepartment,
  jobLocation,
  jobUrl
}) {
  return /*#__PURE__*/_react.default.createElement(Job, null, /*#__PURE__*/_react.default.createElement(JobInner, null, /*#__PURE__*/_react.default.createElement(JobTitle, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 2,
    text: jobTitle
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: jobDepartment,
    as: "paragraph"
  })), /*#__PURE__*/_react.default.createElement(JobLocation, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: jobLocation,
    as: "paragraph"
  })), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement("a", {
    href: jobUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "arrow-right",
    width: 30,
    height: 30
  }))))));
}
JobCard.propTypes = {
  jobTitle: _propTypes.default.string,
  jobDepartment: _propTypes.default.string,
  jobLocation: _propTypes.default.string,
  jobUrl: _propTypes.default.string
};